module.exports = __webpack_public_path__ + "media/images/about-us/PGA/Michigan PGA-782de64a79cc37a288ae1bebd270a4d4.jpg";